import styled from 'styled-components';

export const Flex = styled.div<{
  flexDirection?: string;
  rowGap?: string;
  columnGap?: string;
  alignItems?: string;
  justifyContent?: string;
  margin?: string;
  width?: string;
  background?: string;
  border?: string;
  borderRadius?: string;
  padding?: string;
  cursor?: string;
  gridColumn?: string;
  overflow?: string;
  height?: string;
  wrap?: string;
  boxShadow?: string;
}>`
  box-sizing: border-box;
  display: flex;
  flex-direction: ${props => props.flexDirection};
  row-gap: ${props => props.rowGap};
  column-gap: ${props => props.columnGap};
  align-items: ${props => props.alignItems};
  justify-content: ${props => props.justifyContent};
  margin: ${props => props.margin};
  background: ${props => props.background};
  border-radius: ${props => props.borderRadius};
  padding: ${props => props.padding};
  cursor: ${props => props.cursor};
  width: ${props => props.width};
  height: ${props => props.height};
  grid-column: ${props => props.gridColumn};
  overflow: ${props => props.overflow};
  flex-wrap: ${props => props.wrap};
  box-shadow: ${props => props.boxShadow};
  border: ${props => props.border};
`;

export const Grid = styled.div<{
  gridGap?: string;
  margin?: string;
  width?: string;
  background?: string;
  borderRadius?: string;
  padding?: string;
  cursor?: string;
  gtc?: string;
  gtr?: string;
  alignItems?: string;
}>`
  display: grid;
  margin: ${props => props.margin};
  background: ${props => props.background};
  border-radius: ${props => props.borderRadius};
  padding: ${props => props.padding};
  cursor: ${props => props.cursor};
  width: ${props => props.width};
  align-items: ${props => props.alignItems};
  grid-template-columns: ${props => props.gtc};
  grid-template-rows: ${props => props.gtr};
  grid-gap: ${props => props.gridGap};
`;

export const Text = styled.div<{
  fontSize?: string;
  fontWeight?: number;
  color?: string;
  margin?: string;
  textDecoration?: string;
  whiteSpace?: string;
  cursor?: string;
  textAlign?: string;
  textTransform?: string;
  left?: string;
  fontFamily?: string;
  display?: string;
  lineHeight?: string;
}>`
  margin: ${props => props.margin ?? 0};
  font-size: ${props => props.fontSize};
  font-weight: ${props => props.fontWeight ?? 400};
  color: ${props => props.color};
  text-decoration: ${props => props.textDecoration};
  white-space: ${props => props.whiteSpace ?? 'break-spaces'};
  cursor: ${props => props.cursor};
  text-align: ${props => props.textAlign};
  text-transform: ${props => props.textTransform};
  left: ${props => props.left};
  font-family: ${props => props.fontFamily};
  display: ${props => props.display};
  line-height: ${props => props.lineHeight};
`;

export const StyledButton = styled.button<{
  width?: string;
  background: string;
  color?: string;
  margin?: string;
  alignSelf?: string;
  columnGap?: string;
  rowGap?: string;
  fontSize?: string;
  fontWeight?: number;
  padding?: string;
  backgroundDisabled?: string;
  border?: string;
  lineHeight?: string;
}>`
  outline: none;
  border: ${props => props.border ?? 'none'};
  margin: ${props => props.margin};
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: ${props => props.alignSelf};
  padding: ${props => props.padding ?? '8px 16px'};
  background: ${props => props.background};
  color: ${props => props.color ?? '#FFFFFF'};
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  column-gap: ${props => props.columnGap};
  row-gap: ${props => props.rowGap};
  width: ${props => props.width};
  font-size: ${props => props.fontSize};
  font-weight: ${props => props.fontWeight ?? 400};
  line-height: ${props => props.lineHeight};
  &:disabled {
    opacity: 0.5;
    background: ${props => props.backgroundDisabled};
  }
`;

export const Image = styled.img<{ width?: string; height?: string; cursor?: string; borderRadius?: string }>`
  width: ${props => props.width};
  height: ${props => props.height};
  cursor: ${props => props.cursor};
  border-radius: ${props => props.borderRadius};
`;

export const CommonButtonClose = styled.button`
  cursor: pointer;
  background: transparent;
  border: none;
`;

export const CourseText = styled.div<{
  fontSize?: string;
  fontWeight?: number;
  color?: string;
  margin?: string;
  textDecoration?: string;
  whiteSpace?: string;
  cursor?: string;
  textAlign?: string;
  textTransform?: string;
  left?: string;
  fontFamily?: string;
}>`
  margin: ${props => props.margin ?? 0};
  font-size: '30px';
  font-weight: ${props => props.fontWeight ?? 400};
  color: ${props => props.color};
  text-decoration: ${props => props.textDecoration};
  white-space: ${props => props.whiteSpace ?? 'break-spaces'};
  cursor: ${props => props.cursor};
  text-align: ${props => props.textAlign};
  text-transform: ${props => props.textTransform};
  left: ${props => props.left};
  font-family: ${props => props.fontFamily};
  cursor: pointer;
  text-decoration: underline;
`;
